import { render, staticRenderFns } from "./SingleOrders.vue?vue&type=template&id=dda06486&scoped=true&"
import script from "./SingleOrders.vue?vue&type=script&lang=js&"
export * from "./SingleOrders.vue?vue&type=script&lang=js&"
import style0 from "./SingleOrders.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SingleOrders.vue?vue&type=style&index=1&id=dda06486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda06486",
  null
  
)

component.options.__file = "SingleOrders.vue"
export default component.exports